export const formatWorkoutCardDuration = (totalSeconds: number | null) => {
  if (!totalSeconds || !Number.isFinite(totalSeconds)) return null;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);
  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export const formatWorkoutCardPace = (paceMin: number, unit: string) => {
  const totalSeconds = Math.round(paceMin * 60);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const suffix = unit === "min/mi" ? "/mi" : "/km";
  return `${minutes}:${seconds.toString().padStart(2, "0")} ${suffix}`;
};
